module.exports = __webpack_public_path__ + "static/template_options_1_day-f963527debdf1321e57e84dd6ffd7b77.png";